import React from 'react';

const Uganda1_university_eco = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_university_eco;
